import React from "react";
import { Chip } from "@mui/material";

export type Status =
  | "ATENCAO"
  | "CRITICO"
  | "OK"
  | "null"
  | "inactive"
  | "success"
  | "warning"
  | "danger"
  | "active"
  | "info"
  | "disabled";

interface StatusChipProps {
  status: Status;
  label?: string;
}

const statusStyles: Record<Status, { backgroundColor: string; color: string }> =
  {
    OK: { backgroundColor: "#EAF7EE", color: "#1E8E3E" },
    ATENCAO: { backgroundColor: "#fff8e1", color: "#F9AB00" },
    CRITICO: { backgroundColor: "#fce8e6", color: "#D93025" },
    null: { backgroundColor: "#f1f3f4", color: "#5f6368" },
    disabled: { backgroundColor: "#f1f3f4", color: "#5f6368" },
    success: { backgroundColor: "#EAF7EE", color: "#1E8E3E" },
    active: { backgroundColor: "#EAF7EE", color: "#1E8E3E" },
    warning: { backgroundColor: "#fff8e1", color: "#F9AB00" },
    inactive: { backgroundColor: "#fce8e6", color: "#D93025" },
    danger: { backgroundColor: "#fce8e6", color: "#D93025" },
    info: { backgroundColor: "#EAF1FB", color: "#1264C7" },
  };

export const StatusChip: React.FC<StatusChipProps> = ({ status, label }) => {
  const style = statusStyles[status] || statusStyles["null"];
  const parseLabel = (lblStatus: Status, lblCustom?: string) => {
    if (lblCustom) return lblCustom;
    switch (lblStatus) {
      case "ATENCAO":
        return "Atenção";
      case "CRITICO":
        return "Crítico";
      case "OK":
        return "Ok";
      case "active":
        return "Ativo";
      case "warning":
        return "Cópia";
      case "inactive":
        return "Suspenso";
      case "danger":
        return "Perigo";
      default:
        return "-";
    }
  };
  return (
    <Chip
      icon={
        <span
          aria-hidden="true"
          style={{
            width: 6,
            height: 6,
            borderRadius: 999,
            background: "currentColor",
            marginLeft: 10,
            display: "inline-block",
          }}
        />
      }
      label={parseLabel(status, label)}
      size="small"
      sx={{
        ...style,
        fontFamily: "var(--font-sans)",
        fontWeight: 600,
        fontSize: "12px",
        borderRadius: "12px",
        height: "24px",
        "& .MuiChip-icon": { color: "inherit", marginRight: "-4px" },
      }}
    />
  );
};
